const cSaveNotifierTimeoutLimit = 1000 * 60 * 5
const cSaveNotifierSendToServerTimeoutLimit = 1000 * 60 * 1.5

export {cSaveNotifierTimeoutLimit, cSaveNotifierSendToServerTimeoutLimit}
